[
  {
    "id": "urn:li:industry:1",
    "label": "Defense & Space"
  },
  {
    "id": "urn:li:industry:3",
    "label": "Computer Hardware"
  },
  {
    "id": "urn:li:industry:4",
    "label": "Computer Software"
  },
  {
    "id": "urn:li:industry:5",
    "label": "Computer Networking"
  },
  {
    "id": "urn:li:industry:6",
    "label": "Internet"
  },
  {
    "id": "urn:li:industry:7",
    "label": "Semiconductors"
  },
  {
    "id": "urn:li:industry:8",
    "label": "Telecommunications"
  },
  {
    "id": "urn:li:industry:9",
    "label": "Law Practice"
  },
  {
    "id": "urn:li:industry:10",
    "label": "Legal Services"
  },
  {
    "id": "urn:li:industry:11",
    "label": "Management Consulting"
  },
  {
    "id": "urn:li:industry:12",
    "label": "Biotechnology"
  },
  {
    "id": "urn:li:industry:13",
    "label": "Medical Practice"
  },
  {
    "id": "urn:li:industry:14",
    "label": "Hospital & Health Care"
  },
  {
    "id": "urn:li:industry:15",
    "label": "Pharmaceuticals"
  },
  {
    "id": "urn:li:industry:16",
    "label": "Veterinary"
  },
  {
    "id": "urn:li:industry:17",
    "label": "Medical Device"
  },
  {
    "id": "urn:li:industry:18",
    "label": "Cosmetics"
  },
  {
    "id": "urn:li:industry:19",
    "label": "Apparel & Fashion"
  },
  {
    "id": "urn:li:industry:20",
    "label": "Sporting Goods"
  },
  {
    "id": "urn:li:industry:21",
    "label": "Tobacco"
  },
  {
    "id": "urn:li:industry:22",
    "label": "Supermarkets"
  },
  {
    "id": "urn:li:industry:23",
    "label": "Food Production"
  },
  {
    "id": "urn:li:industry:24",
    "label": "Consumer Electronics"
  },
  {
    "id": "urn:li:industry:25",
    "label": "Consumer Goods"
  },
  {
    "id": "urn:li:industry:26",
    "label": "Furniture"
  },
  {
    "id": "urn:li:industry:27",
    "label": "Retail"
  },
  {
    "id": "urn:li:industry:28",
    "label": "Entertainment"
  },
  {
    "id": "urn:li:industry:29",
    "label": "Gambling & Casinos"
  },
  {
    "id": "urn:li:industry:30",
    "label": "Leisure, Travel & Tourism"
  },
  {
    "id": "urn:li:industry:31",
    "label": "Hospitality"
  },
  {
    "id": "urn:li:industry:32",
    "label": "Restaurants"
  },
  {
    "id": "urn:li:industry:33",
    "label": "Sports"
  },
  {
    "id": "urn:li:industry:34",
    "label": "Food & Beverages"
  },
  {
    "id": "urn:li:industry:35",
    "label": "Motion Pictures & Film"
  },
  {
    "id": "urn:li:industry:36",
    "label": "Broadcast Media"
  },
  {
    "id": "urn:li:industry:37",
    "label": "Museums & Institutions"
  },
  {
    "id": "urn:li:industry:38",
    "label": "Fine Art"
  },
  {
    "id": "urn:li:industry:39",
    "label": "Performing Arts"
  },
  {
    "id": "urn:li:industry:40",
    "label": "Recreational Facilities & Services"
  },
  {
    "id": "urn:li:industry:41",
    "label": "Banking"
  },
  {
    "id": "urn:li:industry:42",
    "label": "Insurance"
  },
  {
    "id": "urn:li:industry:43",
    "label": "Financial Services"
  },
  {
    "id": "urn:li:industry:44",
    "label": "Real Estate"
  },
  {
    "id": "urn:li:industry:45",
    "label": "Investment Banking"
  },
  {
    "id": "urn:li:industry:46",
    "label": "Investment Management"
  },
  {
    "id": "urn:li:industry:47",
    "label": "Accounting"
  },
  {
    "id": "urn:li:industry:48",
    "label": "Construction"
  },
  {
    "id": "urn:li:industry:49",
    "label": "Building Materials"
  },
  {
    "id": "urn:li:industry:50",
    "label": "Architecture & Planning"
  },
  {
    "id": "urn:li:industry:51",
    "label": "Civil Engineering"
  },
  {
    "id": "urn:li:industry:52",
    "label": "Aviation & Aerospace"
  },
  {
    "id": "urn:li:industry:53",
    "label": "Automotive"
  },
  {
    "id": "urn:li:industry:54",
    "label": "Chemicals"
  },
  {
    "id": "urn:li:industry:55",
    "label": "Machinery"
  },
  {
    "id": "urn:li:industry:56",
    "label": "Mining & Metals"
  },
  {
    "id": "urn:li:industry:57",
    "label": "Oil & Energy"
  },
  {
    "id": "urn:li:industry:58",
    "label": "Shipbuilding"
  },
  {
    "id": "urn:li:industry:59",
    "label": "Utilities"
  },
  {
    "id": "urn:li:industry:3131",
    "label": "Mobile Games"
  },
  {
    "id": "urn:li:industry:60",
    "label": "Textiles"
  },
  {
    "id": "urn:li:industry:61",
    "label": "Paper & Forest Products"
  },
  {
    "id": "urn:li:industry:62",
    "label": "Railroad Manufacture"
  },
  {
    "id": "urn:li:industry:63",
    "label": "Farming"
  },
  {
    "id": "urn:li:industry:64",
    "label": "Ranching"
  },
  {
    "id": "urn:li:industry:65",
    "label": "Dairy"
  },
  {
    "id": "urn:li:industry:66",
    "label": "Fishery"
  },
  {
    "id": "urn:li:industry:67",
    "label": "Primary/Secondary Education"
  },
  {
    "id": "urn:li:industry:68",
    "label": "Higher Education"
  },
  {
    "id": "urn:li:industry:69",
    "label": "Education Management"
  },
  {
    "id": "urn:li:industry:70",
    "label": "Research"
  },
  {
    "id": "urn:li:industry:71",
    "label": "Military"
  },
  {
    "id": "urn:li:industry:72",
    "label": "Legislative Office"
  },
  {
    "id": "urn:li:industry:73",
    "label": "Judiciary"
  },
  {
    "id": "urn:li:industry:74",
    "label": "International Affairs"
  },
  {
    "id": "urn:li:industry:75",
    "label": "Government Administration"
  },
  {
    "id": "urn:li:industry:76",
    "label": "Executive Office"
  },
  {
    "id": "urn:li:industry:77",
    "label": "Law Enforcement"
  },
  {
    "id": "urn:li:industry:78",
    "label": "Public Safety"
  },
  {
    "id": "urn:li:industry:79",
    "label": "Public Policy"
  },
  {
    "id": "urn:li:industry:80",
    "label": "Marketing & Advertising"
  },
  {
    "id": "urn:li:industry:81",
    "label": "Newspapers"
  },
  {
    "id": "urn:li:industry:82",
    "label": "Publishing"
  },
  {
    "id": "urn:li:industry:83",
    "label": "Printing"
  },
  {
    "id": "urn:li:industry:84",
    "label": "Information Services"
  },
  {
    "id": "urn:li:industry:85",
    "label": "Libraries"
  },
  {
    "id": "urn:li:industry:86",
    "label": "Environmental Services"
  },
  {
    "id": "urn:li:industry:87",
    "label": "Package/Freight Delivery"
  },
  {
    "id": "urn:li:industry:88",
    "label": "Individual & Family Services"
  },
  {
    "id": "urn:li:industry:89",
    "label": "Religious Institutions"
  },
  {
    "id": "urn:li:industry:90",
    "label": "Civic & Social Organization"
  },
  {
    "id": "urn:li:industry:91",
    "label": "Consumer Services"
  },
  {
    "id": "urn:li:industry:92",
    "label": "Transportation/Trucking/Railroad"
  },
  {
    "id": "urn:li:industry:93",
    "label": "Warehousing"
  },
  {
    "id": "urn:li:industry:94",
    "label": "Airlines/Aviation"
  },
  {
    "id": "urn:li:industry:95",
    "label": "Maritime"
  },
  {
    "id": "urn:li:industry:96",
    "label": "Information Technology & Services"
  },
  {
    "id": "urn:li:industry:97",
    "label": "Market Research"
  },
  {
    "id": "urn:li:industry:98",
    "label": "Public Relations & Communications"
  },
  {
    "id": "urn:li:industry:99",
    "label": "Design"
  },
  {
    "id": "urn:li:industry:100",
    "label": "Non-profit Organization Management"
  },
  {
    "id": "urn:li:industry:101",
    "label": "Fundraising"
  },
  {
    "id": "urn:li:industry:102",
    "label": "Program Development"
  },
  {
    "id": "urn:li:industry:103",
    "label": "Writing & Editing"
  },
  {
    "id": "urn:li:industry:104",
    "label": "Staffing & Recruiting"
  },
  {
    "id": "urn:li:industry:105",
    "label": "Professional Training & Coaching"
  },
  {
    "id": "urn:li:industry:106",
    "label": "Venture Capital & Private Equity"
  },
  {
    "id": "urn:li:industry:107",
    "label": "Political Organization"
  },
  {
    "id": "urn:li:industry:108",
    "label": "Translation & Localization"
  },
  {
    "id": "urn:li:industry:109",
    "label": "Computer Games"
  },
  {
    "id": "urn:li:industry:110",
    "label": "Events Services"
  },
  {
    "id": "urn:li:industry:111",
    "label": "Arts & Crafts"
  },
  {
    "id": "urn:li:industry:112",
    "label": "Electrical & Electronic Manufacturing"
  },
  {
    "id": "urn:li:industry:113",
    "label": "Online Media"
  },
  {
    "id": "urn:li:industry:114",
    "label": "Nanotechnology"
  },
  {
    "id": "urn:li:industry:115",
    "label": "Music"
  },
  {
    "id": "urn:li:industry:116",
    "label": "Logistics & Supply Chain"
  },
  {
    "id": "urn:li:industry:117",
    "label": "Plastics"
  },
  {
    "id": "urn:li:industry:118",
    "label": "Computer & Network Security"
  },
  {
    "id": "urn:li:industry:119",
    "label": "Wireless"
  },
  {
    "id": "urn:li:industry:120",
    "label": "Alternative Dispute Resolution"
  },
  {
    "id": "urn:li:industry:121",
    "label": "Security & Investigations"
  },
  {
    "id": "urn:li:industry:122",
    "label": "Facilities Services"
  },
  {
    "id": "urn:li:industry:123",
    "label": "Outsourcing/Offshoring"
  },
  {
    "id": "urn:li:industry:124",
    "label": "Health, Wellness & Fitness"
  },
  {
    "id": "urn:li:industry:125",
    "label": "Alternative Medicine"
  },
  {
    "id": "urn:li:industry:126",
    "label": "Media Production"
  },
  {
    "id": "urn:li:industry:127",
    "label": "Animation"
  },
  {
    "id": "urn:li:industry:128",
    "label": "Commercial Real Estate"
  },
  {
    "id": "urn:li:industry:129",
    "label": "Capital Markets"
  },
  {
    "id": "urn:li:industry:130",
    "label": "Think Tanks"
  },
  {
    "id": "urn:li:industry:131",
    "label": "Philanthropy"
  },
  {
    "id": "urn:li:industry:132",
    "label": "E-learning"
  },
  {
    "id": "urn:li:industry:133",
    "label": "Wholesale"
  },
  {
    "id": "urn:li:industry:134",
    "label": "Import & Export"
  },
  {
    "id": "urn:li:industry:135",
    "label": "Mechanical Or Industrial Engineering"
  },
  {
    "id": "urn:li:industry:136",
    "label": "Photography"
  },
  {
    "id": "urn:li:industry:137",
    "label": "Human Resources"
  },
  {
    "id": "urn:li:industry:138",
    "label": "Business Supplies & Equipment"
  },
  {
    "id": "urn:li:industry:139",
    "label": "Mental Health Care"
  },
  {
    "id": "urn:li:industry:140",
    "label": "Graphic Design"
  },
  {
    "id": "urn:li:industry:141",
    "label": "International Trade & Development"
  },
  {
    "id": "urn:li:industry:142",
    "label": "Wine & Spirits"
  },
  {
    "id": "urn:li:industry:143",
    "label": "Luxury Goods & Jewelry"
  },
  {
    "id": "urn:li:industry:144",
    "label": "Renewables & Environment"
  },
  {
    "id": "urn:li:industry:145",
    "label": "Glass, Ceramics & Concrete"
  },
  {
    "id": "urn:li:industry:146",
    "label": "Packaging & Containers"
  },
  {
    "id": "urn:li:industry:147",
    "label": "Industrial Automation"
  },
  {
    "id": "urn:li:industry:148",
    "label": "Government Relations"
  },
  {
    "id": "urn:li:industry:150",
    "label": "Horticulture"
  }
]
